import React from 'react';
import PropTypes from 'prop-types';
import { plPL, DataGridPro, GRID_CHECKBOX_SELECTION_COL_DEF, useGridApiRef } from '@mui/x-data-grid-pro';
import { Box, LinearProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useResponsive } from '../../../services/hooks';

const RootStyle = styled('div')({
  flexGrow: 1,
  display: 'flex',
  overflow: 'hidden',
  flexDirection: 'column'
});


const Table = ({ dataGridProps, toolbarComponent, toolbarProps, ctx }) => {
  const isDesktop = useResponsive('up', 'lg');
  const apiRef = useGridApiRef();

  const [rowsState, setRowsState] = React.useState({
    page: 0,
    pageSize: 100,
    loading: false,
    sortFields: ['-id'],
    search: undefined
  });

  const [selectionModel, setSelectionModel] = React.useState([]);

  return <RootStyle>
    <Box sx={isDesktop ? { minWidth: { md: 800 }, height: '100%' } : { width: '100%', height: '80vh' }}>
      <DataGridPro
        density="compact"
        apiRef={apiRef}
        disableColumnMenu={true}
        autoPageSize={false}
        rowsPerPageOptions={[10, 25, 50, 100, 250]}
        components={{
          Toolbar: toolbarComponent,
          LoadingOverlay: () => <LinearProgress sx={{ zIndex: 2 }} />
        }}
        componentsProps={{
          toolbar: toolbarProps,
          row: {
            style: { cursor: 'context-menu' }
          }
        }}
        onColumnWidthChange={e => ctx.handleColumnWidthChange?.(e.colDef)}
        onColumnOrderChange={e => ctx.handleColumnsOrderChange?.(apiRef.current.getAllColumns().map(colDef => colDef.field))}
        initialState={{ pinnedColumns: { left: [GRID_CHECKBOX_SELECTION_COL_DEF.field, 'Szczegóły'] } }}
        localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
        checkboxSelection
        disableSelectionOnClick

        pagination

        {...rowsState}

        paginationMode="client"
        onPageChange={page => setRowsState(prev => ({ ...prev, page }))
        }
        onPageSizeChange={pageSize => setRowsState(prev => ({ ...prev, pageSize }))
        }
        onSelectionModelChange={newSelectionModel => {
          setSelectionModel(newSelectionModel);
        }}
        selectionModel={selectionModel}
        // sortingMode="server"
        {...dataGridProps}

      />
    </Box>
  </RootStyle>;
};

Table.propTypes = {
  toolbarProps: PropTypes.object.isRequired,
  toolbarComponent: PropTypes.node.isRequired,
  dataGridProps: PropTypes.object.isRequired
};


export default Table;
